import {
    Exercise,
    GhostButton,
    LabelBody,
    LabelDisplay1,
    LabelDisplay2,
    SecondaryButton,
    Spacer,
} from '../../components';
import { ExerciseStatus } from '../../interfaces';
import { VideoExerciseView } from '../../views';
import { ExerciseData, ExerciseViewProps } from '../exercises';

export const exerciseData31Intro: ExerciseData = {
    ExerciseView: Module3S1ExerciseIntro,
    dataKeys: [],
    questions: [],
};

export function Module3S1ExerciseIntro({
    exercise,
    onContinue,
}: ExerciseViewProps) {
    if (exercise.CurrentPage === 2) {
        return (
            <Exercise title="Viden om...">
                <LabelDisplay1 className="mb-10">
                    Dette modul er anderledes end de andre
                </LabelDisplay1>
                <LabelBody className="mb-10">
                    Hvis vi ikke tjekker ind, med det der betyder noget for os,
                    får vi heller ikke prioriteret tid til det. En del af det at
                    finde en bedre balance er derfor, at du tjekker ind med dig
                    selv og tager stilling til, hvad der kan være relevant for
                    dig lige nu. Det kan alle øvelserne hjælpe dig med på hver
                    sin måde, og derfor er alle øvelserne åbne.
                </LabelBody>
                <LabelBody className="mb-10">
                    Vi anbefaler, at du kigger dem igennem og starter med den,
                    du synes virker mest interessant. Derefter kan du tage det
                    lidt af gangen og prøve de andre øvelser af, så du når dem
                    inden din sidste samtale med din psykolog.
                </LabelBody>
                <LabelBody className="mb-10">
                    Hvis du er i tvivl om, hvor du skal starte, anbefaler vi, at
                    du starter med “Dit kompas”.
                </LabelBody>
                <Spacer />
                <SecondaryButton
                    className="self-center"
                    onClick={() =>
                        onContinue({
                            status: ExerciseStatus.Completed,
                            goToNext: true,
                        })
                    }
                >
                    Lad os komme i gang
                </SecondaryButton>
                <GhostButton
                    className="mt-20 self-center"
                    onClick={() =>
                        onContinue({
                            status: ExerciseStatus.Completed,
                            goToNext: false,
                        })
                    }
                >
                    Vender tilbage senere
                </GhostButton>
            </Exercise>
        );
    } else {
        return (
            <Exercise title="Viden om...">
                <LabelDisplay2 className="mb-10">
                    Hvorfor det er vigtigt at tjekke ind med dig selv?
                </LabelDisplay2>
                <LabelBody>
                    Hvad kan det give at tage stilling til, hvad der betyder
                    noget for én, og hvordan man lige nu vil prioritere sin tid?
                    Og hvordan kan det at prioritere tid til det, der er vigtigt
                    for en, hjælpe med bekymringer og tankemylder?
                </LabelBody>
                <VideoExerciseView className="mt-20" exercise={exercise} />
                <Spacer class="mt-20" />
                <SecondaryButton
                    className="self-center"
                    onClick={() =>
                        onContinue({
                            status: ExerciseStatus.InProgress,
                            pageNumber: 2,
                        })
                    }
                >
                    Videre
                </SecondaryButton>
            </Exercise>
        );
    }
}
